import React from "react";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import Navbar3 from "../../components/navbars/Navbar3";
import { listDossiers } from "../../actions/medecinPS/medecinActions";
import { getpdfMPS } from "../../actions/depotActions";

import PDF from "../../components/Pdf";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import MaterialTable from "material-table";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import { Divider } from "@mui/material";
import Button from "@mui/material/Button";

import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import CircularProgress from "@mui/material/CircularProgress";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Container from "@mui/material/Container";

import { styled } from "@mui/material/styles";

function MedecinDashboard() {
  const dispatch = useDispatch();

  // var
  const medecinPSLogin = useSelector((state) => state.medecinPSLogin);
  const { loading, error, medecinPSInfo } = medecinPSLogin;
  const dossierList = useSelector((state) => state.dossierList);
  const { loading: loadingD, error: errorD, dossiers } = dossierList;
  const pdfPageMPS = useSelector((state) => state.pdfPageMPS);
  const { pdfMPS } = pdfPageMPS;

  const [tableData, setTableData] = useState([]);
  const [bodyMessage, setBodyMessage] = useState("");
  const [message, setMessage] = useState(false);
  const [askDepotId, setaskDepotId] = useState();

  // functions
  useEffect(() => {
    if (medecinPSInfo) {
      dispatch(listDossiers(medecinPSInfo.ID_LISTE_MEDECIN));
    }
  }, [medecinPSInfo, dispatch]);
  // get id dossier whene its clicked
  const askIdDossier = (id) => {
    console.log(id);
    dispatch(getpdfMPS(id));
    setaskDepotId(id);
  };

  // datagrid function

  const handleRowClick = (params) => {
    setMessage(true);
    setBodyMessage("");
  };

  const theme = createTheme({
    palette: {
      background: {
        default: "red",
      },
    },
  });
  const Item = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: "center",
  }));

  return (
    <Navbar3>
      <ThemeProvider theme={theme}>
        <Grid container spacing={2} sx={{ marginY: 5 }} justifyContent="center">
          <Grid item md={4} xs={12}>
            <Divider sx={{ marginY: 1 }}>
              <Chip label="Liste des dossiers" />
            </Divider>
            <Paper>
              <Box sx={{ height: 400, width: 1 }}>
                {loadingD ? (
                  <Backdrop
                    sx={{
                      color: "#fff",
                      zIndex: (theme) => theme.zIndex.drawer + 1,
                    }}
                    open={true}
                  >
                    <CircularProgress color="inherit" />
                  </Backdrop>
                ) : errorD ? (
                  <div>{errorD}</div>
                ) : (
                  <MaterialTable
                    title="Alerts"
                    columns={[
                      {
                        title: "Patient",
                        field: "NOM_PRENOM_PATIENT",
                        render: (rowData) => (
                          <Grid
                            container
                            sx={{ mt: 1 }}
                            onClick={() => askIdDossier(rowData.ID_DEPOT)}
                          >
                            <Grid>
                              <Chip
                                label={"#" + rowData.NUMERO_DDE}
                                size="small"
                                color="default"
                              />
                            </Grid>
                            <Grid sx={{ ml: 1 }}>
                              <Typography>{rowData.ID_DEPOT}</Typography>
                            </Grid>
                          </Grid>
                        ),

                        width: "5%",
                      },
                      {
                        title: "Date",
                        render: (rowData) => (
                          <Typography
                            sx={{ fontSize: "15px" }}
                            onClick={() => askIdDossier(rowData.ID_DEPOT)}
                          >
                            {"Déposé le " +
                              rowData.DATE_DEPOT_DEMANDE +
                              " (" +
                              rowData.PERIODE_DEPOT_DEMANDE +
                              ")"}
                          </Typography>
                        ),
                        customFilterAndSearch: (term, rowData) =>
                          rowData.DATE_DEPOT_DEMANDE.indexOf(term) != -1,
                      },
                    ]}
                    data={dossiers}
                    actions={[
                      {
                        icon: "visibility",
                        tooltip: "modifier",
                        onClick: (event, rowData) =>
                          askIdDossier(rowData.ID_DEPOT),
                      },
                      // {
                      //   icon: "delete",
                      //   tooltip: "supprimer",
                      //   onClick: (event, rowData) =>
                      //     askDeleteCitoyen(rowData.user.id),
                      // },
                    ]}
                    options={{
                      actionsColumnIndex: -1,
                      search: true,
                      filtering: true,
                      rowStyle: (rowData) => ({
                        backgroundColor:
                          askDepotId === rowData.ID_DEPOT ? "#EEE" : "#FFF",
                      }),
                    }}
                  />
                )}
              </Box>
            </Paper>
          </Grid>
          <Grid item md={7} xs={12}>
            <Divider sx={{ marginY: 1 }}>
              <Chip label="Résultat à visualiser" />
            </Divider>
            <Box sx={{ display: "flex", justifyContent: "end ", mb: 1 }}>
              {askDepotId && (
                <Button
                  color="success"
                  variant="contained"
                  href={
                    "http://" +
                    window.location.hostname +
                    "/core/pdfMedecinPC.php?id=" +
                    askDepotId
                  }
                  target="_blank"
                  // onClick={(e) => printPdf(askDepotId)}
                  startIcon={<DownloadForOfflineIcon />}
                >
                  Télécharge les résultats
                </Button>
              )}{" "}
            </Box>

            <Paper>
              <Box
                sx={{
                  p: 6,
                  mb: 2,
                  height: 500,
                  maxHeight: 500,
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                  overflowY: "scroll",
                  bgcolor: "#fff",
                  boxShadow: 5,
                }}
              >
                {pdfMPS && <PDF pdf={pdfMPS} />}
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </ThemeProvider>
    </Navbar3>
  );
}

export default MedecinDashboard;
